var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.54 4.43A1.5 1.5 0 002 5.92v12a1.51 1.51 0 001.51 1.5h16.95A1.52 1.52 0 0022 17.87v-12a1.51 1.51 0 00-1.52-1.49zm0 1.28h16.92a.2.2 0 01.22.21v8.48l-3.28-2.58a.69.69 0 00-.78 0l-3.07 2.08-4.18-3.36a.64.64 0 00-.48-.14.56.56 0 00-.3.12l-5.26 3.57V5.92a.2.2 0 01.22-.21zm10 1.7a1.93 1.93 0 102 1.92 1.95 1.95 0 00-2.02-1.92zm0 1.28a.64.64 0 11-.65.66.63.63 0 01.63-.66zm-4.6 3.15l4.17 3.32a.7.7 0 00.78 0L17 13.12l3.72 2.93v1.82a.21.21 0 01-.22.22H3.55a.21.21 0 01-.22-.22v-2.22l5.61-3.81z",
  fill: "#787878"
})));

export default SvgIconImage;